import styled from 'styled-components';

import { body } from '@constants/fonts';

export const CardDiv = styled.div<{ clickable: boolean; isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  padding: 20px 20px 20px 10px;
  ${(props) => props.clickable && 'cursor: pointer;'}
  width: 100%;
  font-family: ${body};
  font-weight: normal;
  font-size: 16px;
  box-sizing: border-box;
  background-color: ${(props) =>
    props.isSelected
      ? props.theme.palette.grey.A200
      : props.theme.palette.background.paper};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  transition: background-color 0.05s linear;
  &:first-of-type {
    border-top: none;
  }
  &:last-of-type {
    border-bottom: none;
  }
  &:hover {
    ${(props) =>
      props.clickable &&
      `background-color: ${props.theme.palette.action.hover};`}
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 70%;
  margin-left: 10px;
`;

export const SubTitle = styled.div<{
  subtitleColor: string;
}>`
  color: ${(props) => props.subtitleColor};
`;

export const Title = styled.div<{
  titleColor: string;
}>`
  color: ${(props) => props.titleColor};
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
`;
